import React from "react";

const formatDate = (timestamp) => {
  if (!timestamp) return "";
  return String(timestamp).slice(0, 10);
};

const formatTime = (timestamp) => {
  if (!timestamp) return "";
  return String(timestamp).replace("T", " ").slice(11, 19);
};

const Timeline = ({ items = [], onView }) => {
  return (
    <div className="relative">
      <div className="hidden sm:block absolute left-24 top-0 bottom-0 w-px bg-blue-300" />
      <div className="space-y-4">
        {items.map((item, idx) => (
          <div key={item.id || idx} className="flex flex-col sm:flex-row items-start">
            <div className="flex sm:block sm:w-24 items-center gap-2 text-sm text-blue-600 sm:text-right sm:pr-3 mb-1 sm:mb-0">
              <div className="font-semibold">{formatDate(item.timestamp)}</div>
              <div className="text-xs text-gray-500">
                {formatTime(item.timestamp)}
              </div>
            </div>
            <div className="w-full sm:ml-4 sm:flex-1 min-w-0">
              <div className="bg-blue-50 border-l-4 border-blue-300 rounded-lg p-3 shadow-sm text-sm relative">
                {/* border triangle (left accent) — desktop rail only */}
                <div
                  className="hidden sm:block absolute"
                  style={{
                    left: "-12px",
                    top: "8px",
                    width: 0,
                    height: 0,
                    borderTop: "8px solid transparent",
                    borderBottom: "8px solid transparent",
                    borderRight: "8px solid #93C5FD",
                  }}
                />
                {/* inner triangle to match background, masks right/bottom edges */}
                <div
                  className="hidden sm:block absolute"
                  style={{
                    left: "-8px",
                    top: "9px",
                    width: 0,
                    height: 0,
                    borderTop: "7px solid transparent",
                    borderBottom: "7px solid transparent",
                    borderRight: "7px solid #93C5FD",
                  }}
                />
                <div className="flex justify-between items-start gap-2">
                  <div className="min-w-0">
                    <div className="text-sm font-medium text-gray-800 break-words">
                      {item.action}
                    </div>
                    <div className="text-xs text-blue-700 break-words">
                      By: {item.actorId || "system"}
                    </div>
                  </div>
                </div>

                {item.remark && (
                  <div className="mt-1 text-sm text-gray-700 break-words">
                    Remark: {item.remark}
                  </div>
                )}

                <div className="mt-1 text-xs text-gray-600">
                  <div>
                    <div className="font-semibold">New:</div>
                    {item.newValue ? (
                      <div
                        className="prose-sm mt-0 break-words overflow-x-auto"
                        dangerouslySetInnerHTML={{ __html: item.newValue }}
                      />
                    ) : (
                      <div className="text-gray-400">-</div>
                    )}
                  </div>
                  <div className="mt-1">
                    <div className="font-semibold">Old:</div>
                    {item.oldValue ? (
                      <div
                        className="prose-sm mt-0 break-words overflow-x-auto"
                        dangerouslySetInnerHTML={{ __html: item.oldValue }}
                      />
                    ) : (
                      <div className="text-gray-400">-</div>
                    )}
                  </div>
                </div>

                {/* <div className="mt-3 flex justify-end">
                  <button
                    onClick={() => onView && onView(item)}
                    className="px-3 py-1 bg-gray-200 rounded text-sm"
                  >
                    View
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Timeline;
